module.exports = __webpack_public_path__ + "media/images/self_destructing1-69dc54c6531848bf462dbf0d139b84f9.png";